//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useState, useRef } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  CardContent,
} from '@mui/material';

// === COMPONENTS ===
import { OptionEnabled } from './components/OptionEnabled';
import { OptionAnimate } from './components/OptionAnimate';

//#endregion

//-----------------------------------------------------------------
export function FieldSnippetsMenu() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const ref    = useRef();
  const theme  = useTheme();

  const [is_open, setIsOpen] = useState(false);
  
  const _hover_theme = theme.palette.mode === 'light' ? 'secondary' : 'primary';

  const _styles = {
    container: {
      display    : 'flex'  ,
      marginLeft : 'auto'  ,
      alignItems : 'center',
      padding    : '0.5rem' ,
      cursor     : 'pointer',

      zIndex: '50',
      '&:hover': {
        background: theme.palette.background[_hover_theme][theme.palette.mode],
      },
    },
    dropdown: {
      display: is_open ? '' : 'none',
      top: '6rem',
      right: '12rem',
      position: 'absolute',
      padding: 0,
    },
    icon: {
      color: theme.palette.primary.main,
    },
    info: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '-0.5px 0.5px 3px black',
      width: '100%',
      padding:'0.5rem',
      borderRadius: '0.5rem 0rem 0.5rem 0.5rem',
      
      text: {
        paddingLeft: '0.5rem',
      }
    }
  }

  //#endregion

  useEffect(() => {
    if(is_open) document.addEventListener   ( 'click', handleClickOutside, true );
    else        document.removeEventListener( 'click', handleClickOutside, true );

    return () => {
      if(is_open) document.removeEventListener('click', handleClickOutside, true);
    };
  }, [is_open]);

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function toggle() {
    //-----------------------------------------------------------------
    setIsOpen(!is_open);
  };

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  }

  //#endregion
  
  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display(){
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} ref={ref} onClick={toggle}>
        <Box sx={_styles.text}> Field Snippets </Box>
        <Box sx={_styles.dropdown}>
          <Box sx={_styles.info}>
            <OptionEnabled />
            <OptionAnimate />
          </Box>
        </Box>
      </Box>
    )
  }

  //#endregion

  return display();
}
